import { render } from "./SectionDownload.vue?vue&type=template&id=0e05bed8&scoped=true"
import script from "./SectionDownload.vue?vue&type=script&lang=js"
export * from "./SectionDownload.vue?vue&type=script&lang=js"

import "./SectionDownload.vue?vue&type=style&index=0&id=0e05bed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e05bed8"]])

export default __exports__